import React from 'react';
import PaymentSuccessComponent from '../components/PaymentSuccess';

const PaymentSuccess = () => {
  return <PaymentSuccessComponent />;
};

export default PaymentSuccess;
